import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FloatingMenuComponent } from './floating-menu.component'
import { SharedModule } from '../shared/shared.module'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'



@NgModule({
  declarations: [FloatingMenuComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbCollapseModule
  ],
  exports: [FloatingMenuComponent]
})
export class FloatingMenuModule { }
